import { Injectable } from '@angular/core';
import { DocumentModel } from '../../shared/services/file-saver.service';
import { Observable } from 'rxjs';
import { ApiHttpService } from '../../shared/services/api-http.service';

@Injectable()
export class ReportingService {

  constructor(private apiHttp: ApiHttpService) { }

   public getSeedingReport(parameters: SeedingReportParameters): Observable<DocumentModel> {
    return this.apiHttp.post<DocumentModel>('reports/seeding', parameters);
   }

   public getTransplantReport(parameters: TransplantReportParameters): Observable<DocumentModel> {
    return this.apiHttp.post<DocumentModel>('reports/transplant', parameters);
   }

   public getPollinationReport(parameters: PollinationReportParameters): Observable<DocumentModel> {
     return this.apiHttp.post<DocumentModel>('reports/pollination', parameters);
   }
   
   public getHarvestReport(parameters: HarvestReportParameters): Observable<DocumentModel> {
     return this.apiHttp.post<DocumentModel>('reports/harvest', parameters);
   }

   public getSamplingReport(parameters: SamplingReportParameters): Observable<DocumentModel> {
    return this.apiHttp.post<DocumentModel>('reports/sampling', parameters);
  }

  public getCapacityReport(parameters: CapacityReportParameters): Observable<DocumentModel> {
    return this.apiHttp.post<DocumentModel>('reports/capacity', parameters);
  }
}

export interface SeedingReportParameters {
  startDate: Date,
  endDate: Date,
  cropId?: number,
  containerTypeId?: number,
  substrateId?: number
}

export interface TransplantReportParameters {
  startDate: Date,
  endDate: Date,
  cropId?: number,
  containerTypeId?: number,
  substrateId?: number
}

export interface PollinationReportParameters {
  startDate: Date,
  endDate: Date,
  cropId?: number
}

export interface HarvestReportParameters {
  startDate: Date,
  endDate: Date,
  cropId?: number;
}

export interface SamplingReportParameters {
  plantingStartDate?: Date,
  plantingEndDate?: Date,
  samplingStartDate?: Date,
  samplingEndDate?: Date,
  cropId?: number,
  laboratoryId?: number,
  laboratoryAssayId?: number,
  growthStageId?: number
}

export interface CapacityReportParameters {
  plantingStartDate: Date,
  plantingEndDate: Date,
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/services/reporting.service.ts